export const RESET_WEBVIEW = 'RESET_WEBVIEW';
export const SHOW_WEBVIEW = 'SHOW_WEBVIEW';
export const HIDE_WEBVIEW = 'HIDE_WEBVIEW';
export const SHOW_WEBVIEW_CONTENT = 'SHOW_WEBVIEW_CONTENT';
export const HIDE_WEBVIEW_CONTENT = 'HIDE_WEBVIEW_CONTENT';
export const UPDATE_WEBVIEW_TITLE = 'UPDATE_WEBVIEW_TITLE';
